export const locationColumns = [
  {
    field: 'doctorName',
    headerName: 'Doctor Name',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
  {
    field: 'facilityName',
    headerName: 'Facility',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
  {
    field: 'doctorTypeName',
    headerName: 'Doctor Type',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
  {
    field: 'buildingName',
    headerName: 'Building Name',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => params.value,
  },
  {
    field: 'address',
    headerName: 'Address',
    flex: 1,
    minWidth: 110,
    renderCell: (params) => [params.row.address, params.row.city, params.row.state].filter(Boolean).join(', '),
  },
];
